import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { OFFER_ANCHOR } from './constants';
export function UrgencyBanner() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(29 * 60);
  return <a href={OFFER_ANCHOR} className="block bg-petrol px-3 py-2 text-center text-cream" aria-label="Vai all'offerta" data-id="element-179" data-mp="2nieru82smajz">
      <p className="font-display text-[11px] font-extrabold uppercase tracking-tight sm:text-sm" data-id="element-180" data-mp="2sapu3hl0a8fp">
        🔥 72% DI SCONTO — OFFERTA DI LANCIO{' '}
        <span className="text-mustard" data-id="element-181" data-mp="319juzk5ddkz2">
          {hours}:{minutes}:{seconds}
        </span>
      </p>
    </a>;
}